import React from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { List, ListItemButton, ListItemIcon, SvgIcon, ListItemText } from '@mui/material';
import * as routePaths from 'constants/routes';
import { INTERFACE_BUSINESS, INTERFACE_INDIVIDUAL } from 'constants/interfaces';
import { BusinessIcon, MyResumeIcon, CoverLetterIcon, EmployeesIcon, VacancyIcon, MatchingIcon, MatchingBusinessIcon, UserCircleIcon, KanbanIcon } from 'assets/icons';
import { useStyles } from './styles';
import { useFeatureFlag } from 'context/featureFlagContext';
import { useInterface } from 'context/interfaceContext';
import { useSubscription } from 'context/subscriptionContext';

const SidebarMenu = (props) => {
	const { drawerIsOpen } = props;
	const { interfaceType } = useInterface();
	const { classes } = useStyles();
	const location = useLocation();
	const { matchingEnabled, userManagementEnabled, subscriptionEnabled } = useFeatureFlag();
	const { hasSubscription } = useSubscription();

	const companyHasSubscription = subscriptionEnabled ? hasSubscription || false : true;

	const menuItems = {
		[INTERFACE_BUSINESS]: [
			{
				id: 'companies-list',
				label: 'Companies',
				order: 0,
				icon: BusinessIcon,
				path: routePaths.ROUTE_BUSINESS_COMPANY_LIST,
			},
			{
				id: 'employees-list',
				label: 'Employees',
				order: 1,
				icon: EmployeesIcon,
				path: routePaths.ROUTE_BUSINESS_EMPLOYEES,
				disabled: !companyHasSubscription,
			},
			{
				id: 'vacancies-list',
				label: 'Vacancies',
				icon: VacancyIcon,
				order: 3,
				path: routePaths.ROUTE_BUSINESS_VACANCY_LIST,
				disabled: !companyHasSubscription,
			},
			{
				id: 'kanban',
				label: 'Kanban',
				order: 50,
				icon: KanbanIcon,
				path: routePaths.ROUTE_KANBAN,
				disabled: !companyHasSubscription,
			},
		],
		[INTERFACE_INDIVIDUAL]: [
			{
				id: 'resume-list',
				label: 'My Resume',
				order: 0,
				icon: MyResumeIcon,
				path: routePaths.ROUTE_PERSONAL_MY_RESUME,
			},
			{
				id: 'cover-letters-list',
				label: 'My Cover Letter',
				order: 1,
				icon: CoverLetterIcon,
				path: routePaths.ROUTE_PERSONAL_COVER_LETTERS,
			},
		],
	};

	if (matchingEnabled) {
		menuItems[INTERFACE_BUSINESS].push({
			id: 'matching-cv-list',
			label: 'Matching CVs',
			order: 2,
			icon: MatchingBusinessIcon,
			path: routePaths.ROUTE_BUSINESS_MATCHING,
			disabled: !companyHasSubscription,
		});
		menuItems[INTERFACE_INDIVIDUAL].push({
			id: 'matching-list',
			label: 'Matching',
			order: 2,
			icon: MatchingIcon,
			path: routePaths.ROUTE_PERSONAL_MATCHING,
		});

		menuItems[INTERFACE_INDIVIDUAL].push({
			id: 'match-my-resume-list',
			label: 'Match MyResumeList',
			order: 3,
			icon: MatchingBusinessIcon,
			path: routePaths.ROUTE_PERSONAL_MATCHING_MY_RESUME_LIST,
		});

		menuItems[INTERFACE_BUSINESS].push({
			id: 'match-employee-resumes',
			label: 'Match CVs2',
			icon: MatchingBusinessIcon,
			order: 4,
			path: routePaths.ROUTE_BUSINESS_MATCHING_EMPLOYEE_RESUME,
			disabled: !companyHasSubscription,
		});
	}

	// Menu items for all interfaces
	let additionalMenuItems = [];

	if (userManagementEnabled) {
		additionalMenuItems = [
			...additionalMenuItems,
			{
				id: 'user-management',
				label: 'My account',
				icon: UserCircleIcon,
				order: 100,
				path: routePaths.ROUTE_MY_ACCOUNT,
			},
		];
	}

	return (
		<List component="nav" aria-label="nav" className={classes.root}>
			{menuItems[interfaceType]?.length > 0 &&
				[...menuItems[interfaceType], ...additionalMenuItems]
					.sort((a, b) => a.order - b.order)
					.map(({ id, path, icon, label, ...rest }) => (
						<ListItemButton mb={2} key={id} selected={location.pathname.includes(path)} component={RouterLink} to={path} {...rest}>
							<ListItemIcon>
								<SvgIcon component={icon} inheritViewBox htmlColor="white" sx={{ fill: 'white' }} />
							</ListItemIcon>
							<ListItemText primary={label} sx={{ opacity: drawerIsOpen ? 1 : 0 }} />
						</ListItemButton>
					))}
		</List>
	);
};

export default SidebarMenu;
